import React, { useEffect } from 'react';
import { submitMSISDNAction, moFlowMatch, useMoFlowState, MSISDNEntrySuccess } from 'ouisys-engine/moFlow';
import { useSelector } from 'react-redux';
import { RDS, useStrategyState } from 'ouisys-engine/strategy';
import { useRootContext } from '../../providers/RootContext';
import { handleAutoSubmitMsisdn } from 'ouisys-engine/utilities/handleSubmitNumber';
import { PricePoint, defineMessages, TopLegals } from 'ouisys-component-library';
import PhoneNumberEntryStep from '../../components/PhoneNumberEntryStep';
import { legals } from '../../localization';
import { useDispatch } from '../../__doNotModify/store';
import MO from '../../components/MO';

// error messages messages which might come from backend
const defaultMessages = defineMessages({
  InvalidMSISDN: {
    id: 'InvalidMSISDN',
    defaultMessage: 'This mobile number is incorrect, try again'
  },
  AlreadySubscribed: {
    id: 'AlreadySubscribed',
    defaultMessage: 'You are already a subscriber!'
  },
  UnknownError: {
    id: 'UnknownError',
    defaultMessage: 'An unknown error occurred.'
  },
  TooEarly: {
    id: 'TooEarly',
    defaultMessage: 'You must first submit a mobile number'
  }
});

const MoFlow: React.FC = () => {
  const moFlowState = useMoFlowState(useSelector);
  const strategyState = useStrategyState(useSelector);

  const { isHeaderEnrichmentSuccess } = strategyState?.data || {};
  const { locale, config } = useRootContext();
  const { setMsisdn, msisdn } = useRootContext();

  const dispatch = useDispatch();

  const onEndMsisdn = (msisdn: string) => {
    setMsisdn(msisdn);
    dispatch(submitMSISDNAction({ window, msisdn }));
  };
  useEffect(() => {
    handleAutoSubmitMsisdn({
      window,
      msisdnValue: msisdn,
      dispatch,
      submitMSISDNAction,
      isHeaderEnrichmentSuccess
    });
  }, []);

  return (
    <div className="flow-mo">
      {/* <TopLegals className="top-legals" locale={locale} legals={legals} /> */}

      {moFlowMatch({
        msisdnEntry: (rds) => (
          <>
            {RDS.WhenSuccess<MSISDNEntrySuccess, JSX.Element>(
              <PhoneNumberEntryStep rds={rds} onEnd={onEndMsisdn} />,
              (data) => <MO {...data} />
            )(rds)}
          </>
        )
      })(moFlowState)}

      {/* uncommenting because we didn't have this in our mock up*/}
      {/* <PricePoint className="price-point" locale={locale} legals={legals} flow={config.strategyConfigs.default.flow} /> */}
    </div>
  );
};

export default MoFlow;
